import type { ReactNode } from "react";

export type ValidationState = "invalid" | "success";

/** invalid wins; success only when a success message is present (truthy). */
export function resolveValidationState(
  isInvalid: boolean | undefined,
  successMessage: ReactNode,
): ValidationState | undefined {
  if (isInvalid) return "invalid";
  return successMessage ? "success" : undefined;
}
